import React from 'react';
import times from 'lodash/times';
import { Card } from '../../../../../../CommonComponents/OPL/Card/Card';
import { Shimmer } from '../../../../../../CommonComponents/OPL/Shimmer/Shimmer';
import { TextLoading } from '../../../../../../CommonComponents/OPL/Text/Text.loading';
import { Box } from '../../../../../../CommonComponents/OPL/Box/Box';

export const NetWorthMakeupLoading = () => {
  return (
    <Card p="32" height="100%">
      <TextLoading width={268} height="h3" mb="12" />

      <Shimmer height={24} mb="8" />

      <Box display="flex">
        {times(3).map(key => (
          <Box key={key} display="flex" alignItems="center" mr="16">
            <Shimmer width={8} height={8} borderRadius="full" mr={6} />

            <TextLoading height="h6" width={42} />
          </Box>
        ))}
      </Box>
    </Card>
  );
};
